import { MassUnit } from "../../../../../types/process/process.types";
import {
  ExternalTransportRecord,
  TransportType
} from "../../../../../types/prodcut-data-review/product-data.types";
import { ExternalTransportFormValues } from "../types/externalTransportTable.types";

export const toFormValues = (r: ExternalTransportRecord): ExternalTransportFormValues => ({
  id: r.id,
  name: r.name,
  transportType: r.transportType ?? "",
  from: r.from,
  to: r.to,
  weight: r.weight === "" ? "" : String(r.weight),
  weightUnit: r.weightUnit,
  distance: r.distance === "" ? "" : String(r.distance)
});

export const fromFormValues = (data: ExternalTransportFormValues): Partial<ExternalTransportRecord> => ({
  name: data.name,
  transportType: data.transportType as TransportType | "",
  from: data.from,
  to: data.to,
  weight: data.weight === "" ? "" : Number(data.weight),
  weightUnit: data.weightUnit as MassUnit,
  distance: data.distance === "" ? "" : Number(data.distance)
});
